/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Og_Cfg_Open_RoundsInputs */



/**
* | output |
* | --- |
* | "Open Rounds" |
*
* @param {Og_Cfg_Open_RoundsInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const og_cfg_open_rounds = /** @type {((inputs?: Og_Cfg_Open_RoundsInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Og_Cfg_Open_RoundsInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Rondes libres")
	if (locale === "es") return /** @type {LocalizedString} */ ("Rondas abiertas")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Rodadas abertas")
	if (locale === "it") return /** @type {LocalizedString} */ ("Round liberi")
	return /** @type {LocalizedString} */ ("Open Rounds")
});